export default "__VITE_ASSET__5a977ae4__"